export default __webpack_public_path__ + "static/media/appstore_icon.c96cbe43.svg";